/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetCaseResponseJson } from './get-case-response-json';
import { GetClearanceCaseResult } from '../results/get-clearance-case-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ClearanceCaseDto } from '../models/clearance-case-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetCaseResponse extends ResponseWithErrorGeneric<GetCaseResponseJson, GetClearanceCaseResult> implements IResponseWithErrorGeneric<GetClearanceCaseResult> {
  public clearanceCase: ClearanceCaseDto;

  //<custom-body>
  constructor(response: HttpResponse<GetCaseResponse>) {
    super(response, GetClearanceCaseResult.Error);

    if (this.result !== GetClearanceCaseResult.Success) {
      return;
    }

    this.clearanceCase = this.body.clearanceCase ? new ClearanceCaseDto(this.body.clearanceCase, null) : null;
  }
  //</custom-body>
}
